// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1HourSchema } from './v1/hourSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const showHourPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Time entry ID"),
});

export const showHourQueryParamsSchema = z.object({
  include_linked_metadata: z.optional(z.boolean().describe("When true, response includes a linked_work_items array with id, title, and sync_status.")),
}).optional();

export const showHourHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Time entry details
 */
export const showHour200Schema = z.lazy(() => v1HourSchema);

/**
 * @description Unauthorized
 */
export const showHour401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Time entry not found
 */
export const showHour404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const showHourQueryResponseSchema = z.lazy(() => showHour200Schema);
